import React from "react";
import { Navigate } from "react-router-dom";

/** Redirects to /dashboard when the given capability/role check is false. */
function RequireRole({ allowed, children }) {
  if (!allowed) {
    return <Navigate to="/dashboard" replace />;
  }

  return children;
}

export default RequireRole;
